import React from 'react';
import { Shield } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const CookiesPage = () => {
  const { language } = useLanguage();
  
  return (
    <div className="max-w-4xl mx-auto px-4 py-12" data-testid="cookies-page">
      <div className="text-center mb-12">
        <div className="w-16 h-16 rounded-full bg-[#1E3A5F]/10 flex items-center justify-center mx-auto mb-4">
          <Shield className="text-[#1E3A5F]" size={32} />
        </div>
        <h1 className="section-title mb-4">{language === 'gr' ? 'Πολιτική Cookies' : 'Cookie Policy'}</h1>
        <p className="text-slate-600">{language === 'gr' ? 'Πληροφορίες για τα cookies που χρησιμοποιούμε' : 'Information about the cookies we use'}</p>
      </div>
      <div className="card p-8">
        <section className="mb-8">
          <p className="text-slate-600">
            {language === 'gr' 
              ? 'Ο ιστότοπος www.wbl.gr χρησιμοποιεί cookies για τη σωστή λειτουργία και βελτίωση της εμπειρίας πλοήγησης.'
              : 'The website www.wbl.gr uses cookies for proper operation and to improve the browsing experience.'}
          </p>
        </section>
        <section className="mb-8">
          <h2 className="text-xl font-bold text-[#1E3A5F] mb-4">{language === 'gr' ? 'Τι είναι τα cookies' : 'What are cookies'}</h2>
          <p className="text-slate-600">
            {language === 'gr' 
              ? 'Τα cookies είναι μικρά αρχεία κειμένου που αποθηκεύονται στη συσκευή σας κατά την επίσκεψη στον ιστότοπο.'
              : 'Cookies are small text files stored on your device when you visit the website.'}
          </p>
        </section>
        <section className="mb-8">
          <h2 className="text-xl font-bold text-[#1E3A5F] mb-4">{language === 'gr' ? 'Τύποι cookies που χρησιμοποιούμε' : 'Types of cookies we use'}</h2>
          <div className="space-y-4">
            <div className="bg-slate-50 rounded-lg p-4">
              <h3 className="font-semibold text-[#1E3A5F] mb-2">{language === 'gr' ? 'Απαραίτητα cookies' : 'Essential cookies'}</h3>
              <p className="text-slate-600 text-sm">
                {language === 'gr' 
                  ? 'Απαιτούνται για τη βασική λειτουργία του ιστότοπου.'
                  : 'Required for the basic operation of the website.'}
              </p>
            </div>
            <div className="bg-slate-50 rounded-lg p-4">
              <h3 className="font-semibold text-[#1E3A5F] mb-2">{language === 'gr' ? 'Στατιστικά cookies' : 'Analytics cookies'}</h3>
              <p className="text-slate-600 text-sm">
                {language === 'gr' 
                  ? 'Χρησιμοποιούνται για την ανώνυμη ανάλυση επισκεψιμότητας (εφόσον χρησιμοποιούνται π.χ. Google Analytics).'
                  : 'Used for anonymous traffic analysis (if Google Analytics is used).'}
              </p>
            </div>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-green-50 border border-green-200 rounded-lg p-4">
            <p className="text-green-800 font-medium">
              {language === 'gr' 
                ? 'Δεν χρησιμοποιούμε cookies για εμπορική εκμετάλλευση ή πώληση δεδομένων.'
                : 'We do not use cookies for commercial exploitation or data sales.'}
            </p>
          </div>
        </section>
        <section>
          <h2 className="text-xl font-bold text-[#1E3A5F] mb-4">{language === 'gr' ? 'Διαχείριση cookies' : 'Cookie management'}</h2>
          <p className="text-slate-600">
            {language === 'gr' 
              ? 'Μπορείτε να διαχειριστείτε ή να διαγράψετε τα cookies μέσω των ρυθμίσεων του προγράμματος περιήγησης.'
              : 'You can manage or delete cookies through your browser settings.'}
          </p>
        </section>
      </div>
      <p className="text-center text-slate-400 text-sm mt-8">{language === 'gr' ? 'Τελευταία ενημέρωση: Φεβρουάριος 2026' : 'Last updated: February 2026'}</p>
    </div>
  );
};

export default CookiesPage;
